import { render, staticRenderFns } from "./ClassCard.vue?vue&type=template&id=a863fc70&scoped=true&"
import script from "./ClassCard.vue?vue&type=script&lang=ts&"
export * from "./ClassCard.vue?vue&type=script&lang=ts&"
import style0 from "./ClassCard.vue?vue&type=style&index=0&id=a863fc70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a863fc70",
  null
  
)

export default component.exports